import axios from "axios";

const BASE = process.env.REACT_APP_API_URL || "http://localhost:3000/api/v1";

const client = axios.create({ baseURL: BASE });

// Attach token if present
client.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("kq_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

// ── Auth ──────────────────────────────────────────────────────────────────────
export const authAPI = {
  register: (body) => client.post("/auth/register", body),
  login:    (body) => client.post("/auth/login",    body),
  me:       ()     => client.get("/auth/me"),
};

// ── Orders ────────────────────────────────────────────────────────────────────
export const ordersAPI = {
  create:  (body)    => client.post("/orders",            body),
  get:     (id)      => client.get(`/orders/${id}`),
  track:   (id)      => client.get(`/orders/${id}`),
  myOrders:()        => client.get("/orders?limit=20"),
};

// ── B2B / Developer Portal ────────────────────────────────────────────────────
export const b2bAPI = {
  register:       (body)        => client.post("/b2b/register",     body),
  login:          (body)        => client.post("/b2b/login",        body),
  // Self-service — authenticated with API key in X-API-Key header
  me:             (apiKey)      => client.get("/b2b/me",            { headers: { "X-API-Key": apiKey } }),
  regenerate:     (apiKey)      => client.post("/b2b/me/regenerate",{},         { headers: { "X-API-Key": apiKey } }),
  updateWebhook:  (apiKey, url) => client.put("/b2b/me/webhook",    { webhook_url: url }, { headers: { "X-API-Key": apiKey } }),
  deleteAccount:  (apiKey)      => client.delete("/b2b/me",         { headers: { "X-API-Key": apiKey } }),
  webhookLogs:    (apiKey)      => client.get("/b2b/webhook-logs",  { headers: { "X-API-Key": apiKey } }),
  apiLogs:        (apiKey)      => client.get("/b2b/api-logs",      { headers: { "X-API-Key": apiKey } }),
};

// ── Investment Partners ───────────────────────────────────────────────────────
export const investAPI = {
  /**
   * Register an investment partner and save their intent.
   * Called before opening the Paystack popup.
   * @param {{ name, email, phone, package, amount, reference }} body
   */
  register: (body) => client.post("/invest/register", body),

  /**
   * Confirm payment after Paystack callback succeeds.
   * @param {{ reference, paystack_ref }} body
   */
  confirm: (body) => client.post("/invest/confirm", body),
};

export default client;